<template>
  <div class="dialog-add-note">
    <el-input
      v-if="!editText"
      v-model="newText"
      type="textarea"
      :rows="10"
      maxlength="1000"
      resize="none"
      show-word-limit
    />
    <el-input
      v-else
      :value="editText"
      type="textarea"
      :rows="10"
      maxlength="1000"
      resize="none"
      show-word-limit
      @input="changeEditText"
    />
    <OptionsButtons
      :text-positive="'Save'"
      :disabled-okay="disabledButton"
      @pushedPositive="saveNote"
    />
  </div>
</template>

<script>
import config from "../../nuxt.config";

export default {
  name: "AddNote",
  components: {
    OptionsButtons: () => import("../dialog/OptionsButtons"),
  },
  data() {
    return {
      newText: "",
      loading: false,
    };
  },
  computed: {
    editText() {
      return this.$store.state.Dialog.textNote;
    },
    disabledButton() {
      if (this.editText) {
        return false;
      } else {
        return !this.newText;
      }
    },
  },
  methods: {
    changeEditText(val) {
      this.$store.commit("Dialog/setData", { label: "textNote", data: val });
    },
    saveNote() {
      this.loading = true;
      const forNote = this.$store.state.Dialog.noteFor;
      const isFixed = this.$store.state.Dialog.currentFixed;
      const id = this.$store.state.Dialog.currentNote;
      const method = this.editText ? "PATCH" : "POST";
      const alertText = this.editText
        ? "Note edited. You can retrieve this note in the My notes section of MyPC"
        : "Note added. You can retrieve this note in the My notes section of MyPC";
      const url = this.editText
        ? `${config.env.BASE_URL}/admin/content/note/${id}?_format=json`
        : `${config.env.BASE_URL}/entity/note?_format=json`;
      const data = {
        page_id: [forNote.page],
        body: [
          {
            value: this.editText ? this.editText : this.newText,
            format: "basic_html",
          },
        ],
        fixed: [isFixed !== null ? isFixed : false],
      };
      if (forNote.section) data.section_id = [forNote.section];
      this.$axios({
        method,
        url,
        data,
      })
        .then(() => {
          this.loading = false;
          this.$store.commit("Dialog/setData", {
            label: "updateList",
            data: forNote,
          });
          this.$store.commit("Dialog/setData", {
            label: "baseDialogOpen",
            data: false,
          });
          this.$store.commit("Dialog/setData", { label: "textNote", data: "" });
          this.$store.commit("Dialog/setData", {
            label: "currentNote",
            data: null,
          });
          this.$store.commit("Dialog/setData", {
            label: "currentFixed",
            data: null,
          });
          this.newText = "";
          setTimeout(() => {
            this.$alert(alertText, {
              confirmButtonText: "OK",
            });
          }, 200);
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss">
.dialog-add-note {
  width: 100%;
  .el-textarea {
    &__inner {
      border: none !important;
      color: #000;
    }
    .el-input__count {
      left: 0;
      bottom: -3rem;
      width: 20%;
      font-size: 1.2rem;
      font-weight: 600;
    }
  }
}
</style>
